import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../services/api';
import { DollarSign } from 'lucide-react';

const ESTAGIOS = [
  { id: 'novo', label: 'Novo', color: 'bg-gray-400' },
  { id: 'contato_feito', label: 'Contato Feito', color: 'bg-blue-500' },
  { id: 'visita_agendada', label: 'Visita Agendada', color: 'bg-indigo-500' },
  { id: 'proposta_enviada', label: 'Proposta Enviada', color: 'bg-purple-500' },
  { id: 'negociacao', label: 'Negociação', color: 'bg-yellow-500' },
  { id: 'reservado', label: 'Reservado', color: 'bg-orange-500' },
  { id: 'vendido', label: 'Vendido', color: 'bg-green-500' },
];

export default function PipelineKanban() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({
    queryKey: ['pipeline'],
    queryFn: () => api.get('/pipeline').then(r => r.data.data),
    refetchInterval: 30000,
  });

  const advance = useMutation({
    mutationFn: ({ id, novoEstagio }) => api.put(`/leads/${id}`, { estagio_funil: novoEstagio }),
    onSuccess: () => qc.invalidateQueries(['pipeline']),
  });

  if (isLoading) return <div className="p-8 text-center text-gray-400">Carregando...</div>;

  const kanban = data || {};

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-gray-800">Pipeline de Negócios</h1>
      <div className="flex gap-4 overflow-x-auto pb-4">
        {ESTAGIOS.map((col, colIdx) => (
          <div key={col.id} className="flex-shrink-0 w-72">
            <div className={`${col.color} text-white px-4 py-2 rounded-t-lg flex justify-between`}>
              <span className="text-sm font-semibold">{col.label}</span>
              <span className="bg-white bg-opacity-30 text-xs px-2 py-0.5 rounded-full">
                {(kanban[col.id] || []).length}
              </span>
            </div>
            <div className="bg-gray-100 rounded-b-lg p-2 space-y-2 min-h-32">
              {(kanban[col.id] || []).map(n => (
                <div key={n.id} className="bg-white rounded-lg p-3 shadow-sm">
                  <p className="font-semibold text-sm text-gray-800">{n.lead_nome}</p>
                  <p className="text-xs text-gray-500">{n.empreendimento_nome || '—'}</p>
                  <p className="text-xs text-secondary mt-1">
                    {n.responsavel_nome ? `Responsável: ${n.responsavel_nome}` : ''}
                  </p>
                  <div className="flex flex-wrap gap-1 mt-2">
                    <span className={`text-xs px-2 py-0.5 rounded-full ${
                      n.temperatura === 'quente' ? 'bg-red-100 text-red-700' :
                      n.temperatura === 'morno' ? 'bg-yellow-100 text-yellow-700' :
                      'bg-blue-100 text-blue-700'
                    }`}>
                      {n.temperatura || 'neutro'}
                    </span>
                  </div>
                  <button
                    onClick={() => advance.mutate({ id: n.id, novoEstagio: ESTAGIOS[colIdx + 1]?.id })}
                    disabled={colIdx >= ESTAGIOS.length - 1 || advance.isPending}
                    className="w-full mt-2 py-1 text-xs bg-gray-50 hover:bg-gray-100 text-gray-600 rounded border border-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {colIdx < ESTAGIOS.length - 1 ? 'Avançar →' : '✓ Final'}
                  </button>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
